import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { supabase } from '../../api/supabase'
import { inputCls, btnPrimary, btnSecondary } from './types'

export default function NewWarehouse() {
  const navigate = useNavigate()
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [form, setForm] = useState({ code: '', name: '', address_line1: '', address_city: '', address_postcode: '' })
  const set = (k: string, v: string) => setForm(p => ({ ...p, [k]: v }))

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!form.code.trim() || !form.name.trim()) { setError('Code and Name are required'); return }
    setSaving(true); setError(null)
    const address = {
      line1: form.address_line1,
      city: form.address_city,
      postcode: form.address_postcode,
    }
    const { data, error: err } = await supabase
      .from('warehouses')
      .insert({ code: form.code.toUpperCase().trim(), name: form.name.trim(), address })
      .select('id')
      .single()
    if (err) { setError(err.message); setSaving(false); return }
    navigate(`/warehouse/${data.id}`)
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-8 max-w-xl">
        <Link to="/warehouse" className="text-sm text-blue-600 hover:underline mb-4 block">← Warehouses</Link>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">New Warehouse</h1>
        <form onSubmit={handleSubmit} className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Code *</label>
              <input required className={inputCls} value={form.code} onChange={e => set('code', e.target.value)} placeholder="BHX" maxLength={10} />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Name *</label>
              <input required className={inputCls} value={form.name} onChange={e => set('name', e.target.value)} placeholder="Birmingham Hub" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Address Line 1</label>
            <input className={inputCls} value={form.address_line1} onChange={e => set('address_line1', e.target.value)} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">City</label>
              <input className={inputCls} value={form.address_city} onChange={e => set('address_city', e.target.value)} />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Postcode</label>
              <input className={inputCls} value={form.address_postcode} onChange={e => set('address_postcode', e.target.value)} />
            </div>
          </div>
          {error && <p className="text-red-600 text-sm">{error}</p>}
          <div className="flex justify-end gap-3 pt-2">
            <Link to="/warehouse" className={btnSecondary}>Cancel</Link>
            <button type="submit" disabled={saving} className={btnPrimary}>{saving ? 'Creating...' : 'Create Warehouse'}</button>
          </div>
        </form>
      </div>
    </div>
  )
}
